// import "./components/isotope.js";
import "./components/tiny-slider.js";
import "./components/detectBrowser.js";
// import "./components/accordion.js";

(function ($) {
    $(document).ready(function () {
        mapLegend();
        animationLine();
        AOS.init();
        window.addEventListener('load', AOS.refreshHard);

        /**
         * Smooth scroll
         */
        // Select all links with hashes
        $('a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function(event) {
                // On-page links
                if (
                    location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                    &&
                    location.hostname == this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $('html, body').animate({
                            scrollTop: target.offset().top
                        }, 1000);
                    }
                }
            });


        /**
         * Map section
         */
        // Marker hover
        $('.map-section [data-marker]').hover(
            function() {
                let markerData = $(this).attr('data-marker');
                $('[data-marker='+ markerData +']').addClass('hover');
            }, function() {
                $('[data-marker]').removeClass("hover");
            }
        );
        if( $('.map-section').length > 0 ) {
            $('.map-section__places-label').first().addClass('active');
            $('.map-section__places').first().show();
            $('.map-section__marker[data-marker*="Culture"]').show();

        }
        // Label click
        $('.map-section__places-label').click(function() {
            
            if( $(this).hasClass('active') ) {

            } else {
                let dataCat = $(this).attr('data-catmarkers');
                $('.map-section__places-label').removeClass('active');
                $('.map-section__places-label').next('div').slideUp();
                $(this).addClass('active');
                $(this).next('div').slideDown();

                $('.map-section__marker[data-marker]').stop().fadeOut();
                $('.map-section__marker[data-marker*="'+ dataCat +'"]').stop().fadeIn();
            }
        });
        
        /**
         * Top bar close
         */
        $('.bar-download__close').click(function() {
            $('.bar-download').slideUp();
        });

        $('.bar-download__btn').click(function(e) {
            e.preventDefault();

            $(this).toggleClass('active');
            $('.bar-download__links').stop().slideToggle();
        });

        /**
         * Video RWD
         */
        if( $('.video-item__data').length > 0 ) {
            /**
             * Link file RWD
             */
            let mainData = $('.video-item__data'),
                desktop = mainData.attr('data-desktop'),
                tablet = (( desktop.length < 1 ) ? mainData.attr('data-tablet') : desktop),
                mobile = (( desktop.length < 1 ) ? mainData.attr('data-mobile') : desktop),
                mainVideo = mainData.find('video');

            mainData.each(function() {
                if ($(window).width() > 1024) {
                    mainVideo.append("<source type='video/mp4' src='" + desktop + "' />");
                } else if( $(window).width() <= 1024 && $(window).width() >= 768 ) {
                    mainVideo.append("<source type='video/mp4' src='" + tablet + "' />");
                } else {
                    mainVideo.append("<source type='video/mp4' src='" + mobile + "' />");
                }
            });

            mainVideo.click(function() {
                // videoFn();
            });

            /**
             * Video play and pause 
             */
            function videoFn() {
                let videoID = mainVideo.attr('id'); 

                if(document.getElementById(videoID)) {
                    document.getElementById(videoID).play();
                }
            };
        }

        /**
         * Toggle main menu
         */
        // $('.burger-menu').click(function(){
        //     let header = $('header');

        //     if( $(this).hasClass('active') ) {
        //         setTimeout(function(){
        //             $('.burger-menu').removeClass('active');
        //             header.toggleClass('active-menu');
        //         }, 750);
                
        //         $('.nav-mobile').delay(500).slideToggle('slow');
        //         $('.nav-mobile').children().toggleClass('visible')
        //     } else {
        //         $(this).addClass('active');
        //         header.toggleClass('active-menu');

        //         $('.nav-mobile').slideToggle('slow').children().toggleClass('visible');
        //     }
        // });

        /**
         * HR next <p>&nbsp;</p> hide
         */
        $('hr').each(function(){
            let emptyP = $(this).next('p');
            
            if ( emptyP.html() === '&nbsp;' ) {
                emptyP.remove();
            }
        });

        /**
         * Skip intro
         */
        $('.skip-intro').click(function(){
            $('html, body').animate({
                scrollTop: $(window).outerHeight()
            }, 1000);
        });
        
    });

    mapLegend();

    window.onload=function() {
        mapLegend()
    };

    $(window).resize(function() {
        mapLegend();
    });

    $(document).scroll(function() {
        animationLine();
    });

    /**
     * Animation line
     */
    function animationLine() {
        let line = $('.animation-line'),
            lineH = line.outerHeight(),
            windowH = $(window).outerHeight(),
            windowHNew = windowH / 2,
            scroll = $(window).scrollTop(),
            scrollTop = scroll + windowHNew,
            footerLine = $('.footer-line').offset(),
            footerLineTop = footerLine.top;

        if( ( $(window).scrollTop() + lineH ) >  footerLineTop ) {
            let heightFL = ( $(window).scrollTop() + lineH ) - footerLineTop;

            $('.footer-line').css('height', heightFL);
        } else {
            $('.footer-line').css('height', '0px');
        }

        if( $(window).scrollTop() <= 50 ) {
            line.css('position','absolute');
        } else {
            line.css('position','fixed');
        }
    }

    /**
     * Map legend accordion
     */
    function mapLegend() {
        let legend = $('.map-section__legend'),
            map = $('.map-section__map'),
            mapH = map.outerHeight(),
            label = $('.map-section__places-label'),
            labelsH = 0,
            places = $('.map-section__places'),
            placesH = 0;

        if( $(window).outerWidth() < 768 ) {
            mapH = 550;
        } else {
            legend.css('height', mapH);
        }

        // Labels height
        label.each(function() {
            // label = $(this).outerHeight();
            labelsH += $(this).outerHeight();
        });
        
        placesH = mapH - labelsH - 10;
        places.css('max-height', placesH);
        
    }
})(jQuery);